import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import TopicCard from "@/components/base/TopicCard";
import { topics } from "@/mocks/topics";

export default function TrendingSection() {
  const list = topics.filter((t) => !t.featured).slice(0, 6);

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          eyebrow="持续更新"
          title="更多追踪中的事件"
          description="按最近更新时间排列，点击任意一条可查看完整的证据链与真假辨析记录。"
        />
        <Link
          to="/topics"
          className="inline-flex items-center gap-1 whitespace-nowrap font-label text-sm text-primary-700 hover:text-primary-600 cursor-pointer"
        >
          浏览全部 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((topic) => (
          <TopicCard key={topic.id} topic={topic} />
        ))}
      </div>
    </section>
  );
}